import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../EnvImpairment/envImpairment.module.scss'

import metadata from './LiabilityExposuresComponent.metadata.json5';

function LiabilityExposuresComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    // eslint-disable-next-line no-secrets/no-secrets
    const { onValidate } = useValidation('LiabilityExposuresComponent');

    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const checkDoAnyOfTheCovLocHav = () => {

        const coveredLocDetailsPath = `${pathUpdated.substring(0, pathUpdated.indexOf(']')+1)  }.coveredLocationsDetails`

        return _.get(submissionVM, `${coveredLocDetailsPath}.doAnyOfTheCovLocHav40.value`)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        exposuresNearSiteContainer: {
            visible: checkDoAnyOfTheCovLocHav()

        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

LiabilityExposuresComponent.propTypes = wizardProps;
export default withRouter(LiabilityExposuresComponent);
